<ng-template [ngIf]="(loading || !item) && showSkeleton">
  <ng-container [ngSwitch]="type">
    <app-skeleton *ngSwitchCase="6" [stats]="'video'"></app-skeleton>
    <app-skeleton *ngSwitchCase="7" [stats]="'article'"></app-skeleton>
    <app-skeleton *ngSwitchCase="8" [stats]="'podcast'"></app-skeleton>
    <app-skeleton *ngSwitchCase="9" [stats]="'image'"></app-skeleton>
    <app-skeleton *ngSwitchDefault [stats]="'lesson'"></app-skeleton>
  </ng-container>
</ng-template>

<span *ngIf="item" inViewport (inViewportAction)="onInViewportTopChange($event)"></span>
<ng-template content-data></ng-template>
<span *ngIf="item" inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>
<ng-template [ngIf]="debug$ | async">
  <div (click)="reloadRating()" class="clickable">
    <p><strong>Популярность:</strong> {{ debugPopularity }}</p>
    <p><strong>Популярность за неделю:</strong> {{ debugPopularityByPeriod }}</p>
    <p><strong>Параметры:</strong> {{ debugParams | json }}</p>
    <p><strong>Статистика урока:</strong> {{ debugStats | json }}</p>
  </div>
</ng-template>
